export enum DOMAINS {
  IN = 'in',
}

type DomainsKeys = keyof typeof DOMAINS;
export type DomainType = (typeof DOMAINS)[DomainsKeys];

export interface MenuItem {
  action?: string;
  highlight?: string;
  href: string;
  logged_in_href?: string;
  label?: string;
  title: string;
  img_key?: string;
}

export interface FooterLink {
  label: string;
  url: string;
}

export interface GroupItem {
  action?: string;
  category?: string;
  label: string;
  links: MenuItem[];
}

export interface SubNav {
  action?: string;
  category?: string;
  links: MenuItem[];
}

export interface MenuInterface {
  className?: string;
  color?: string;
  groups?: GroupItem[];
  href: string;
  logged_in_href?: string;
  label: string;
  subnav?: SubNav;
  title?: string;
  marked?: boolean;
  deviceType?: 'desktop' | 'mobile';
  width?: string;
  subGroupChevron?: boolean;
}

export interface NavigationMenus {
  primary: MenuInterface[];
  secondary: MenuInterface[];
}

export type HeaderVariant = 'default' | 'simple';
export type FooterVariant = 'default' | 'simple';

export interface GlobalNavigationConfig {
  footerVariant: FooterVariant;
  headerVariant: HeaderVariant;
  logoVariant: MainLogoVariant;
  menu: GlobalMenu;
}

export interface FooterNavigationGroup {
  label: string;
  items: FooterLink[];
}

export interface GlobalMenu {
  copyright: FooterLink[];
  footer: FooterNavigationGroup[];
  header: NavigationMenus;
}

export type GlobalRegisterType = 'korean' | 'japanese' | 'spanish' | 'french' | 'italian' | 'american' | 'indian';

export type MainLogoVariant = 'india' | 'japan' | 'korea' | 'default' | 'crypto' | 'spain' | 'italy' | 'france';
